import { Icon, Tooltip } from "@animech/ui";
import { FunctionComponent } from "react";
import * as Styled from "./out-of-stock-warning-element-container.style";
import { useUiData } from "src/ui/data";

export const OutOfStockWarningElementContainer: FunctionComponent = () => {
	const { outOfStockWarningElements, localizer } = useUiData();

	if (!outOfStockWarningElements.length) {
		return null;
	}

	return (
		<Styled.OutOfStockWarningElementContainer>
			{outOfStockWarningElements.map((info, index) => (
				<Styled.OutOfStockWarningElementChild ref={info.onRef} key={index}>
					<Tooltip hideArrow>
						{localizer.localizeTerm("itemNotInStock")}
					</Tooltip>
					<Icon name="notice-fill" color="alert" />
				</Styled.OutOfStockWarningElementChild>
			))}
		</Styled.OutOfStockWarningElementContainer>
	);
};
